export const CLIENTS_ACTIONS = {
    GET_ALL: 'CLIENTS_GET_ALL',
    GET_ACTIVE: 'CLIENTS_GET_ACTIVE',
    FIND: 'CLIENTS_FIND',
    ADD: 'CLIENT_ADD',
    CHANGE_STATUS: 'CLIENTS_CHANGE_STATUS',
    SUCCESS: 'CLIENTS_SUCCESS',
    ERROR: 'CLIENTS_ERROR',
    CLEAN: 'CLIENTS_CLEAN',

    SUGGESTION: 'CLIENTS_SUGGESTION',
    SUGGESTION_CLEAN: 'CLIENTS_SUGGESTION_CLEAN',
}